import React from 'react';

import LegalLayout from './LegalLayout';
import legalConfig from './legalConfig';

const policySections = [
    { number: '01', label: 'Responsable', href: '#responsable' },
    { number: '02', label: 'Datos y finalidades', href: '#datos' },
    { number: '03', label: 'Comunicaciones por WhatsApp', href: '#whatsapp' },
    { number: '04', label: 'Proveedores y conservación', href: '#proveedores' },
    { number: '05', label: 'Derechos y eliminación', href: '#derechos' },
    { number: '06', label: 'Seguridad y menores', href: '#seguridad' },
    { number: '07', label: 'Contacto y vigencia', href: '#vigencia' }
];

const PrivacyPolicy = () => {
    return (
        <LegalLayout
            eyebrow="Información legal y transparencia"
            title="Política de privacidad"
            description="Conoce cómo protegemos la información que compartes con Secundaria Babeque por medio del sitio web y WhatsApp."
        >
            <nav className="legal-index" aria-label="Contenido de la política">
                <div className="legal-index__header">
                    <p className="legal-index__eyebrow">Guía rápida</p>
                    <h2>Contenido de la política</h2>
                    <p>Selecciona una sección para ir directamente a la información que necesitas.</p>
                </div>

                <div className="legal-index__grid">
                    {policySections.map((section) => (
                        <a href={section.href} key={section.href}>
                            <span className="legal-index__number" aria-hidden="true">{section.number}</span>
                            <span className="legal-index__label">{section.label}</span>
                            <span className="legal-index__arrow" aria-hidden="true">→</span>
                        </a>
                    ))}
                </div>
            </nav>

            <section className="legal-section" id="responsable">
                <p className="legal-section__number">01</p>
                <div>
                    <h2>Responsable del tratamiento</h2>
                    <p>
                        <strong>{legalConfig.legalName}</strong>, que opera públicamente como{' '}
                        <strong>{legalConfig.institutionName}</strong>, es responsable del tratamiento descrito en
                        esta política.
                    </p>
                    <dl className="legal-data-list">
                        <div><dt>RNC</dt><dd>{legalConfig.rnc}</dd></div>
                        <div><dt>Área responsable</dt><dd>{legalConfig.privacyArea}</dd></div>
                        <div><dt>Domicilio</dt><dd>{legalConfig.address}</dd></div>
                        <div><dt>Contacto</dt><dd>{legalConfig.privacyEmail}<br />{legalConfig.phone}</dd></div>
                    </dl>
                </div>
            </section>

            <section className="legal-section" id="datos">
                <p className="legal-section__number">02</p>
                <div>
                    <h2>Datos que tratamos y para qué los usamos</h2>
                    <p>
                        Cuando una persona se comunica con la institución podemos recibir su nombre, número de
                        teléfono, correo electrónico, identificador, mensajes, archivos enviados
                        voluntariamente y su relación con la institución.  
                    </p>
                    <p>Utilizamos esta información únicamente para:</p>
                    <ul>
                        <li>Responder consultas y solicitudes de información, admisiones o soporte.</li>
                        <li>Gestionar comunicaciones institucionales autorizadas.</li>
                        <li>Proteger nuestros canales digitales y prevenir usos indebidos.</li>
                        <li>Cumplir obligaciones legales y atender requerimientos de autoridades competentes.</li>
                    </ul>
                </div>
            </section>

            <section className="legal-section" id="whatsapp">
                <p className="legal-section__number">03</p>
                <div>
                    <h2>Comunicaciones mediante WhatsApp</h2>
                    <p>
                        La institución utiliza {legalConfig.metaService} para atender y dar seguimiento a
                        comunicaciones institucionales. Solo iniciaremos mensajes cuando la persona haya proporcionado
                        su número y autorizado el contacto, o cuando la conversación haya sido iniciada por ella.
                    </p>
                    <p>
                        La autorización puede retirarse en cualquier momento respondiendo <strong>DETENER</strong>,
                        solicitando no recibir más mensajes o escribiendo a {legalConfig.privacyEmail}. No utilizaremos
                        los datos recibidos por WhatsApp para finalidades incompatibles con la comunicación solicitada.
                    </p>
                </div>
            </section>

            <section className="legal-section" id="proveedores">
                <p className="legal-section__number">04</p>
                <div>
                    <h2>Proveedores y conservación</h2>
                    <p>
                        Para operar el sitio y el servicio de mensajería podemos utilizar a Meta y a proveedores
                        tecnológicos de alojamiento, correo, seguridad y soporte. Estos proveedores solo deben tratar
                        la información necesaria para prestar sus servicios y conforme a sus obligaciones aplicables.
                        El uso de WhatsApp también está sujeto a las políticas de privacidad de Meta y WhatsApp.
                    </p>
                    <p>
                        Las conversaciones de WhatsApp se conservarán normalmente hasta {legalConfig.whatsappRetention}.
                        Podremos conservar información durante más tiempo cuando exista una relación institucional
                        activa, una obligación legal o sea necesaria para proteger derechos y atender reclamaciones.
                        Vencido el plazo, será eliminada o anonimizada de forma segura.
                    </p>
                </div>
            </section>

            <section className="legal-section" id="derechos">
                <p className="legal-section__number">05</p>
                <div>
                    <h2>Derechos y eliminación de datos</h2>
                    <p>
                        La persona titular puede solicitar acceso a sus datos, conocer su uso y destino, pedir su
                        corrección o actualización y, cuando corresponda, solicitar su eliminación, cancelación u
                        oposición al tratamiento.
                    </p>
                    <p>
                        Para ejercer estos derechos debe escribir a <strong>{legalConfig.privacyEmail}</strong> e
                        indicar su nombre, el número o correo utilizado y la solicitud que desea realizar. Las
                        instrucciones completas están disponibles en{' '}
                        <a href="/eliminacion-de-datos">Eliminación de datos personales</a>.
                    </p>
                </div>
            </section>

            <section className="legal-section" id="seguridad">
                <p className="legal-section__number">06</p>
                <div>
                    <h2>Seguridad y datos de menores</h2>
                    <p>
                        Aplicamos medidas técnicas y organizativas razonables para prevenir la pérdida, alteración o
                        acceso no autorizado a los datos. Nunca solicitaremos contraseñas ni códigos de autenticación
                        por WhatsApp.
                    </p>
                    <p>
                        Por la naturaleza educativa de la institución, recomendamos que las comunicaciones relativas
                        a estudiantes menores sean realizadas por sus padres, madres o tutores. Solo solicitaremos la
                        información necesaria y las autorizaciones que correspondan.
                    </p>
                </div>
            </section>

            <section className="legal-section" id="vigencia">
                <p className="legal-section__number">07</p>
                <div>
                    <h2>Contacto, cambios y vigencia</h2>
                    <p>
                        Para consultas sobre privacidad puedes escribir a <strong>{legalConfig.privacyEmail}</strong>
                        o llamar al {legalConfig.phone}. Esta política entra en vigor el {legalConfig.effectiveDate} y
                        fue actualizada por última vez el {legalConfig.lastUpdated}.
                    </p>
                    <p>
                        Los cambios importantes se publicarán en esta misma página y se mantendrá visible la fecha de
                        la versión vigente.
                    </p>
                </div>
            </section>

            <section className="legal-sources" aria-labelledby="privacy-sources-title">
                <h2 id="privacy-sources-title">Referencias</h2>
                <ul>
                    <li><a href="https://dgii.gov.do/transparencia/marcoLegal/Documents/Leyes/172-13.pdf" target="_blank" rel="noreferrer">Ley 172-13 sobre Protección de Datos Personales</a></li>
                    <li><a href="https://whatsappbusiness.com/policy/" target="_blank" rel="noreferrer">Política de mensajería de WhatsApp Business</a></li>
                </ul>
            </section>
        </LegalLayout>
    );
};

export default PrivacyPolicy;
